<template>
  <div class="mobilePage" :class="{ ios: os.isPhone }">
    <div class="pageA">
      <!-- 顶部：logo + 联系方式 -->
      <div class="header">
        <img src="@/assets/images/landingA/logo.webp" alt="" class="logo" />
        <div class="contactBox">
          <img
            v-if="tgUrl"
            src="@/assets/images/landingA/tg.webp"
            class="contactItem"
            @click="toPage(tgUrl)"
          />
          <img
            v-if="swUrl"
            src="@/assets/images/landingA/sw.webp"
            class="contactItem"
            @click="toPage(swUrl)"
          />
          <img
            v-if="qdUrl"
            src="@/assets/images/landingA/qd.webp"
            class="contactItem"
            @click="toPage(qdUrl)"
          />
        </div>
      </div>
      <!-- 中间：人物轮播（渐入渐出）+ 标题文案 -->
      <div class="stageA">
        <div class="personStage">
          <img
            v-for="(item, index) in slides"
            :key="index"
            class="person"
            :class="{ active: activeIndex === index }"
            :src="item"
            alt=""
          />
        </div>
        <img class="copy" src="@/assets/images/landingA/title.webp" alt="" />
        <div class="covers" aria-hidden="true">
          <div
            v-for="(item, index) in covers"
            :key="item"
            class="cover"
            :class="{ featured: index === 0 }"
          >
            <img
              class="coverFrame"
              src="@/assets/images/landingA/cardframe.webp"
              alt=""
            />
            <img class="coverImage" :src="item" alt="" />
          </div>
        </div>
      </div>
      <!-- 底部：下载按钮 + 提示 -->
      <div class="bottomBox">
        <div class="downRow">
          <img
            v-if="os.isPhone"
            class="downBtn"
            src="@/assets/images/landingA/ios.webp"
            @click.stop="getApkInfo('ios', $event)"
          />
          <img
            v-else
            class="downBtn"
            src="@/assets/images/landingA/android.webp"
            @click.stop="getApkInfo('android', $event)"
          />
          <button
            v-if="switchData.androidDownUrl && switchData.channelApkAndDownUrl"
            class="downBtn spareBtn"
            type="button"
            @click.stop="getApkInfo('androidSpare', $event)"
          >
            备用下载
          </button>
        </div>
        <img class="tip" src="@/assets/images/landingA/tip.webp" alt="" />
      </div>
    </div>

    <!-- 安卓提示框 -->
    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <!-- 苹果提示框 -->
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="appName">熟果短剧</div>
          <div class="desc">钻进被窝偷偷看好片</div>
          <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";
export default {
  props: ["os", "configs", "switchData", "version"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,
      activeIndex: 0,
      slideTimer: null,
      slides: [1, 2, 3, 4].map(index =>
        require(`@/assets/images/landingA/person${index}.webp`)
      ),
      covers: [1, 2, 3, 4].map(index =>
        require(`@/assets/images/landingA/cover${index}.webp`)
      ),

      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
        return newValue;
      });
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
    const referrer = sessionStorage.getItem("referrer");
    const dc = sessionStorage.getItem("dc");
    if (referrer && dc) {
      this.currUrl = referrer + "user.html?dc=" + dc;
    } else {
      if (referrer) {
        this.currUrl = referrer + "user.html";
      } else {
        this.currUrl = window.location.href;
      }
    }
    this.startRotation();
    // 预加载安装教程弹窗背景（藏在 display:none 的 overlay 里不会自动拉取），
    // 防止弹出时正赶上下载跳转被中断
    new Image().src = require("@/assets/images/mobile1/iosTip.png");
    new Image().src = require("@/assets/images/mobile1/android_tip.png");
  },
  beforeDestroy() {
    this.stopRotation();
  },
  methods: {
    // 剪贴板
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {}
      );
    },
    checkIsSafari() {
      let ua = this.os.userAgent.toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      const data = this.switchData || {};
      const isIos = this.os.isPhone;
      // 安卓仅在渠道包地址存在时才自动下载
      const downUrl = isIos ? data.iosDownUrl : data.channelApkAndDownUrl;
      if (!downUrl) return;
      // iOS 非 Safari 浏览器无法下载，已弹 Safari 提示，不自动触发
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        // 下载立即触发，安装教程弹窗延迟 5s 再弹出
        this.getApkInfo(isIos ? "ios" : "android", null, 5000);
      });
    },
    // 等页面资源加载完成再执行，避免下载跳转把加载中的图片全部中断
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      // 兜底：弱网下资源迟迟加载不完也要触发下载
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      // 上报点击（下载按钮）；自动触发时无点击事件，不上报
      if (!event) return;
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y
      });
    },
    startRotation() {
      this.stopRotation();
      this.slideTimer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.slides.length;
      }, 3500);
    },
    stopRotation() {
      if (this.slideTimer) {
        clearInterval(this.slideTimer);
        this.slideTimer = null;
      }
    },
    toPage(path) {
      window.open(path);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.mobilePage {
  height: 100%;
  width: 100%;
  .pageA {
    width: 100%;
    min-height: 100%;
    height: 100dvh;
    background: #1a0308 url("../../../assets/images/landingA/bg.webp") no-repeat
      33% -18.31px;
    background-size: auto 103%;
    overflow: hidden;
    position: relative;
    .header {
      display: flex;
      padding: calc(13.39px + env(safe-area-inset-top)) 8.81px 0;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 120;
      box-sizing: border-box;
    }
    .logo {
      width: 93.1px;
      height: 34.06px;
    }
    .contactBox {
      display: flex;
      align-items: center;
      gap: 12.91px;
      .contactItem {
        width: 54.52px;
        height: 21.52px;
        cursor: pointer;
      }
    }
    .stageA {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      // 原型舞台 100–644px；延续 A 版 flex 居中并为固定下载区留出空间。
      padding-bottom: 24px;
      .personStage {
        position: relative;
        width: 375px;
        height: 295px;
        flex-shrink: 0;
        .person {
          position: absolute;
          inset: 0;
          width: 375px;
          height: 295px;
          opacity: 0;
          transition: opacity 0.8s ease;
          &.active {
            opacity: 1;
          }
        }
      }
      .copy {
        width: 344.33px;
        height: 214.53px;
        margin-top: -81.42px;
        margin-left: 10.11px;
        z-index: 2;
      }
      .covers {
        display: flex;
        width: 340px;
        height: 111.07px;
        gap: 8.47px;
        align-items: center;
        margin-top: 4.89px;
        z-index: 3;
      }
      .cover {
        position: relative;
        width: 77.03px;
        height: 106.07px;
        flex-shrink: 0;
        &.featured {
          width: 80.66px;
          height: 111.07px;
        }
      }
      .coverFrame {
        position: absolute;
        left: -10.47%;
        top: -2.66%;
        width: 115.18%;
        height: 105.01%;
      }
      .coverImage {
        position: absolute;
        left: 1.6%;
        top: 1.31%;
        width: 96.79%;
        height: 97.38%;
        object-fit: cover;
        border-radius: 4.84px;
      }
    }
    .bottomBox {
      z-index: 100;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      padding-bottom: calc(4px + env(safe-area-inset-bottom));
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .downRow {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        .downBtn {
          display: block;
          width: 161.59px;
          height: 38.81px;
          cursor: pointer;
        }
        .spareBtn {
          border: 1px solid #ffdc72;
          border-radius: 20px;
          color: #fff0ae;
          background: linear-gradient(#db1609, #8e0000);
          font-size: 14px;
          font-weight: bold;
          box-shadow: inset 0 0 4px #ffb833;
        }
      }
      .tip {
        display: block;
        width: 375px;
        height: auto;
      }
    }
  }
  @media screen and (max-height: 700px) {
    .pageA .stageA {
      transform: scale(0.85);
      transform-origin: center;
      padding-bottom: 42px;
    }
  }
  @media screen and (max-height: 600px) {
    .pageA .stageA {
      transform: scale(0.72);
      padding-bottom: 55px;
    }
  }
  .androidOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/android_tip.png")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }

  .iosOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/iosTip.png") no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      position: relative;

      .appName {
        font-size: 10px;
        font-weight: 500;
        color: #242423;
        position: absolute;
        left: 79px;
        bottom: 102px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .desc {
        font-size: 7px;
        font-weight: 500;
        color: #8f908f;
        position: absolute;
        left: 79px;
        bottom: 92px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
}

.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;

  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }

  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }

  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }

  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
